<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveGoogleMerchant()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import addCommonSettings from "./common-settings.js";

    export default {
        name: "google-merchant-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty, addCommonSettings],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveGoogleMerchant: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;

                this.channel.items = [
                    {
                        groupingName : "Settings",
                        groupItems : [
                            {
                                name : "google_option_size",
                                label : "Size",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_option_size')) ? cvs.json_options.configuration.google_option_size  : "",
                                options : (cfo.mapping) ? cfo.mapping : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_option_color",
                                label : "Color",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_option_color')) ? cvs.json_options.configuration.google_option_color  : "",
                                options : (cfo.mapping) ? cfo.mapping : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_option_material",
                                label : "Material",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_option_material')) ? cvs.json_options.configuration.google_option_material  : "",
                                options : (cfo.mapping) ? cfo.mapping : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_option_pattern",
                                label : "Pattern",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_option_pattern')) ? cvs.json_options.configuration.google_option_pattern  : "",
                                options : (cfo.mapping) ? cfo.mapping : [],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_target_country",
                                label : "Target Country",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_target_country')) ? cvs.json_options.configuration.google_target_country  : "",
                                options : [
                                    {
                                        "id" : "AU",
                                        "name" : "Australia"
                                    },
                                    {
                                        "id" : "CA",
                                        "name" : "Canada"
                                    },
                                    {
                                        "id" : "FR",
                                        "name" : "France"
                                    },
                                    {
                                        "id" : "DE",
                                        "name" : "Germany"
                                    },
                                    {
                                        "id" : "IT",
                                        "name" : "Italy"
                                    },
                                    {
                                        "id" : "JP",
                                        "name" : "Japan"
                                    },
                                    {
                                        "id" : "NZ",
                                        "name" : "New Zealand"
                                    },
                                    {
                                        "id" : "CH",
                                        "name" : "Switzerland"
                                    },
                                    {
                                        "id" : "TH",
                                        "name" : "Thailand"
                                    },
                                    {
                                        "id" : "GB",
                                        "name" : "United Kingdom"
                                    },
                                    {
                                        "id" : "US",
                                        "name" : "United States"
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_content_language",
                                label : "Content Language",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_content_language')) ? cvs.json_options.configuration.google_content_language  : "",
                                options : [
                                    {
                                        "id" : "de",
                                        "name" : "de"
                                    },
                                    {
                                        "id" : "en",
                                        "name" : "en"
                                    },
                                    {
                                        "id" : "es",
                                        "name" : "es"
                                    },
                                    {
                                        "id" : "fr",
                                        "name" : "fr"
                                    },
                                    {
                                        "id" : "it",
                                        "name" : "it"
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_shipping_weight_unit",
                                label : "Shipping Weight Unit",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_shipping_weight_unit')) ? cvs.json_options.configuration.google_shipping_weight_unit  : "",
                                options : [
                                    {
                                        "id" : "lb",
                                        "name" : "lb"
                                    },
                                    {
                                        "id" : "oz",
                                        "name" : "oz"
                                    },
                                    {
                                        "id" : "g",
                                        "name" : "g"
                                    },
                                    {
                                        "id" : "kg",
                                        "name" : "kg"
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "google_price_currency",
                                label : "Price Currency",
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'google_price_currency')) ? cvs.json_options.configuration.google_price_currency  : "",
                                options : [
                                    {
                                        "id" : "USD",
                                        "name" : "USD"
                                    },
                                    {
                                        "id" : "EUR",
                                        "name" : "EUR"
                                    },
                                    {
                                        "id" : "GBP",
                                        "name" : "GBP"
                                    },
                                    {
                                        "id" : "CAD",
                                        "name" : "CAD"
                                    },
                                    {
                                        "id" : "AUD",
                                        "name" : "AUD"
                                    },
                                    {
                                        "id" : "MXN",
                                        "name" : "MXN"
                                    },
                                    {
                                        "id" : "CHF",
                                        "name" : "CHF"
                                    },
                                    {
                                        "id" : "JPY",
                                        "name" : "JPY"
                                    },
                                    {
                                        "id" : "THB",
                                        "name" : "THB"
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            }
                        ]
                    }
                ]
            }
        },
        mounted() {
            this.setItems();
            this.channel.items = this.addCommonSettings(this.channel.items, this.channelvalues, this.channeloptions);
        },
    };
</script>